import { useQuery } from "@tanstack/react-query";

import { listMeterUploadsByLevel1Resource } from "@services/bulkMeterUpload";

type UseMeterUploadsByLevel1ResourceOptions = {
  options?: Record<string, any>;
};

export const useMeterUploadsByLevel1Resource = (
  level1ResourceId: string | undefined,
  { options }: UseMeterUploadsByLevel1ResourceOptions = {},
) =>
  useQuery<any[]>({
    queryKey: ["meterUploads", level1ResourceId],
    queryFn: () => listMeterUploadsByLevel1Resource(level1ResourceId!),
    enabled: !!level1ResourceId,
    ...options,
  });
